/**
 * Menghitung periode tanggal mulai dan selesai berdasarkan tipe laporan.
 * Mendukung laporan bulanan dengan cut-off tanggal 28 hingga 27 bulan berikutnya,
 * serta laporan tahunan berdasarkan tahun ajaran (Juli ke Juni).
 */
export function getReportPeriod(params: {
  reportType: 'MONTHLY' | 'ANNUAL';
  year: number;
  month?: number; // 0-11, wajib untuk MONTHLY
}) {
  let startDate: Date;
  let endDate: Date;

  if (params.reportType === 'MONTHLY') {
    if (params.month === undefined) {
      throw new Error('Bulan wajib ditentukan untuk laporan bulanan');
    }

    // Menggunakan pendekatan base date untuk menghindari bug JS Date auto-correction
    const base = new Date(params.year, params.month, 1);

    // Tanggal Mulai: 28 bulan sebelumnya
    startDate = new Date(base);
    startDate.setMonth(base.getMonth() - 1);
    startDate.setDate(28);

    // Tanggal Selesai: 27 bulan yang dipilih
    endDate = new Date(params.year, params.month, 27);
  } else {
    // Tahun Ajaran: 1 Juli (Tahun-1) ke 30 Juni (Tahun)
    // Jika input 2025, maka range: 1 Juli 2024 - 30 Juni 2025
    startDate = new Date(params.year - 1, 6, 1);
    endDate = new Date(params.year, 5, 30);
  }

  // Format ke YYYY-MM-DD untuk query database
  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
    displayStart: startDate.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
    displayEnd: endDate.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
  };
}
